import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FeeControlComponent } from "./fee-control.component";
import { IonicModule } from "ionic-angular";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        FeeControlComponent
    ],
    exports: [
        FeeControlComponent
    ]
})
export class FeeControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/fee/form/fee-control.module.ts